import React from 'react';
import { Button } from 'react-bootstrap';
import '../style/counter.css';
import {useSelector,useDispatch} from 'react-redux';
import {incNumber,decNumber} from '../action/index.js';

const Counter = () => {
    const mystate = useSelector((state) => {return (state.changeTheNumber)})
    const dispatch = useDispatch();
    return (
    <>
    <div className="container">
        <h1>Increment/Decrement counter</h1>
        <h4>using React and Redux</h4>

        <div className="quantity"> 
        <Button variant="primary" className="btnplus" onClick={()=>{return dispatch(incNumber(3))}}>+</Button>
         <input name="quantity" type="text" className="quantity_input" value={mystate}></input>
         <Button variant="primary" className="btnminus" onClick={()=>{return dispatch(decNumber())}}>-</Button>   
        </div>
          
    </div>        
    </>
    )
}

export default Counter
